import { getProjectTypeLabel } from '../helpers/dataHelper';
import { ROOM_TYPE } from './roomConstants';

export const THEME_LIGHT = 'theme-light';
export const THEME_DARK = 'theme-dark';

export const TITLE_PREFIX = 'imagine.io';
export const NETWORK_ERROR = 'Network Error';

export const WS_BASE_URL = process.env.REACT_APP_WS_BASE_URL;
export const FAST_PREVIEW_WS_BASE_URL = process.env.REACT_APP_FAST_PREVIEW_WS_BASE_URL;

//ls
export const IS_GAMIFIED_SKIP = 'IS_GAMIFIED_SKIP';
export const SELECTED_PLAN = 'SELECTED_PLAN';
export const START_ONBOARDING = 'START_ONBOARDING';
export const VERIFICATION_TOKEN = 'verification_token';
export const AUTH_TOKEN = 'token';
export const REFRESH_TOKEN = 'refresh_token';
export const MEMBER_ID = 'id';
export const THEME = 'theme';
export const CURRENT_USER = 'current_user';
export const ORG_OWNER_DETAIL = 'owner_detail';
export const IS_ACTIVE_ORG = 'is_active_org';
export const EMAIL_VERIFIED = 'is_email_verified';
export const LATEST_TNC_ACCEPTED = 'latest_tnc_accepted';
export const IN_FULL_SCREEN = 'in_full_screen';
export const INVITE_DATA = 'invite_data';
export const NOTIFICATION_COUNT = 'notification_count';
export const CURRENT_USER_ID = 'currentUserId';
export const GUEST_USER = 'GUEST_USER';
export const IS_PACK_SUBSCRIPTION_USER = 'is_pack_subscription_user';
export const EG_SUBMISSION = "egsubmission" // email gated email submission key
export const IP_ADDRESS = 'IP_ADDRESS'

export const VALID_PASSWORD_MESSAGE = 'Password must be a minimum of 8 characters';
// and must contain a combination of the following: uppercase letters, lowercase letters, numbers, and symbols.';
export const PASSWORD_MATCH_MESSAGE = '';
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 40;

export const RAISE_TICKET_PLACEHOLDER = '{RAISE_TICKET_PLACEHOLDER}';

export const RAISE_TICKET_DEFAULTS = {
  RENDERS_PREVIEWS: {
    title: `I am having an issue with [${RAISE_TICKET_PLACEHOLDER}]'s job renders.`,
    pipeline: {
      value: 77,
      label: 'Renders & Previews',
    },
    description: '',
  },
  RENDERS_PREVIEWS_ANGLE: {
    title: `I am having an issue rendering [${RAISE_TICKET_PLACEHOLDER}].`,
    pipeline: {
      value: 77,
      label: 'Renders & Previews',
    },
    description: '',
  },
};

export const LIGHT_TOAST_OPTIONS = {
  position: 'bottom-center',
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  icon: false,
};

export const DARK_TOAST_OPTIONS = {
  position: 'bottom-center',
  autoClose: 3000,
  hideProgressBar: true,
  theme: 'dark',
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  icon: false,
};

export const SEE_ALL = 'See all';

export const LIVE_FURNISH = {
  id: 2297,
  name: 'imagine.io',
  website: 'https://imagine.io/',
  pricing: 'https://imagine.io/pricing',
  enterprise: 'https://imagine.io/enterprise',
  privacyPolicy: 'https://imagine.io/privacy-policy',
  termsOfUse: 'https://imagine.io/terms-and-conditions-of-use',
  websiteWithChatOpen: 'https://imagine.io#hs-chat-open',
  talkToAnExpert: 'https://imagine.io/talk-to-an-expert',
};

export const NO_BRAND_TAG_ORG = ['imagine.io', 'Pilot Project'];

export const IMAGINE_ORG_ID = 320;

export const KEEP_PREVIEW_FOR_DAYS = 30;

export const CURATOR_DB = 'curator';
export const STORAGE_DB = '/idbfs';

export const CONVERT_IN_METER = 39.37;
export const CONVERT_IN_INCHES = 39.37;
export const TABLE_HEADER_SCROLL_THRESHOLD = 50;
// export const  FILTER_OPTIONS = [
//     { text: "ROOM", value: "1" },
//     { text: "LIFESTYLEROOM", value: "2" },
//     { text: "SILOROOM", value: "3" },
//     { text: "VIGNETTEROOM", value: "4" },
//     { text: "THREESIXTYROOM", value: "5" },
//     { text: "VIDEOROOM", value: "6" },
//     { text: "CONFIGURATORROOM", value: "7" },
//     { text: "AUGMENTED_REALITYROOM", value: "8" },
//   ];

// export const SORT_BY = [
//     {text:'Name',value:'name'},
//     {text:'Old',value:'created_at'},

// ]

export const PER_PAGE_OPTIONS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 500];

export const CURATOR_TYPE = {
  ROOM: 'room',
  PROJECT: 'project',
};

export const FILTER_OPTIONS = [
  { label: 'Filter by' },
  { label: 'ROOM', value: '1' },
  { label: 'LIFESTYLEROOM', value: '2' },
  { label: 'SILOROOM', value: '3' },
  { label: 'VIGNETTEROOM', value: '4' },
  { label: 'THREESIXTYROOM', value: '5' },
  { label: 'VIDEOROOM', value: '6' },
  { label: 'CONFIGURATORROOM', value: '7' },
  { label: 'AUGMENTED_REALITYROOM', value: '8' },
];

export const SORT_BY = [
  { label: 'Sort by' },
  { label: 'Oldest first', value: 'created_at' },
  { label: 'Name:A-Z', value: '2' },
  { label: 'Name:Z-A', value: '3' },
];

export const TEMPLATE_TYPE = {
  LIFESTYLE: ROOM_TYPE.LIFESTYLE,
  SILO: ROOM_TYPE.SILO,
  VIGNETTE: ROOM_TYPE.VIGNETTE,
};

export const AI_VIDEO = {
  VIDEO_PLAYER_ID: '__AI_VIDEO_PREVIEW_PLAYER__',
  START_TIME: 'START_TIME',
  END_TIME: 'END_TIME',
};

export const projectTypeDropdownOptions = [
  {
    label: getProjectTypeLabel(ROOM_TYPE.ROOM),
    value: ROOM_TYPE.ROOM,
  },
  {
    label: getProjectTypeLabel(ROOM_TYPE.LIFESTYLE),
    value: ROOM_TYPE.LIFESTYLE,
  },
  {
    label: getProjectTypeLabel(ROOM_TYPE.SILO),
    value: ROOM_TYPE.SILO,
  },
  {
    label: getProjectTypeLabel(ROOM_TYPE.VIGNETTE),
    value: ROOM_TYPE.VIGNETTE,
  },
  {
    label: getProjectTypeLabel(ROOM_TYPE.THREESIXTY),
    value: ROOM_TYPE.THREESIXTY,
  },
  {
    label: getProjectTypeLabel(ROOM_TYPE.VIDEO),
    value: ROOM_TYPE.VIDEO,
  },
  {
    label: getProjectTypeLabel(ROOM_TYPE.CONFIGURATOR),
    value: ROOM_TYPE.CONFIGURATOR,
  },
  {
    label: getProjectTypeLabel(ROOM_TYPE.AUGMENTED_REALITY),
    value: ROOM_TYPE.AUGMENTED_REALITY,
  },
];

export { ROOM_TYPE };
